import type { ComponentProps } from "react";
import { cn } from "@/lib/utils";
import { Skeleton } from "@/components/ui/skeleton";

/** Mutes pulse when the user prefers reduced motion. */
const motionSafe = "motion-reduce:animate-none motion-reduce:opacity-80";

export function SkeletonLine({ className, ...props }: ComponentProps<typeof Skeleton>) {
  return <Skeleton className={cn("h-3 rounded-md", motionSafe, className)} {...props} />;
}

export function SkeletonAvatar({ className, ...props }: ComponentProps<typeof Skeleton>) {
  return <Skeleton className={cn("size-10 shrink-0 rounded-full", motionSafe, className)} {...props} />;
}

export function SkeletonAvatarSm({ className, ...props }: ComponentProps<typeof Skeleton>) {
  return <Skeleton className={cn("size-9 shrink-0 rounded-full", motionSafe, className)} {...props} />;
}

export function SkeletonBlock({ className, ...props }: ComponentProps<typeof Skeleton>) {
  return <Skeleton className={cn("rounded-xl", motionSafe, className)} {...props} />;
}
